<template>
  <div class="div-columns">
    <div class="columns is-gapless is-centered is-vcentered">
      <div class="column content" :class="[{ 'is-11': full !== 'true' && !columnNum }, columnNum]" :style="[{ paddingTop: (paddingTop ? paddingTop : undefined), paddingBottom: (paddingBottom ? paddingBottom : undefined), backgroundColor: (backgroundColor ? backgroundColor : undefined), textAlign: (textAlign ? textAlign : undefined) }]">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'div-columns',
  props: ['full', 'column-num', 'padding-top', 'padding-bottom', 'background-color', 'text-align'],
  components: {
  },
  data () {
    return {
    }
  },
  computed: {
  },
  watch: {
  },
  created () {
  },
  mounted () {
    this.refresh()
  },
  methods: {
    onScrollTo: function (name) {
      this.$scrollTo('#' + name)
    }.bind(this),

    refresh: function () {
    }
  }
}
</script>

<style lang="scss">
@import "../styles/app_setting.scss";

// div columns
// it serve as inner level in child container
// so top or bottom padding is required

.div-columns {
  .columns.is-gapless > .column {
    &.content {
      padding: 3em 15px;
      @media screen and (min-width: $tablet) {
        padding: 3em 15px;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// DivColumns.vue?2d0fbb96